import {
    AfterContentChecked,
    ChangeDetectorRef,
    Component,
    OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { PROGRESS_NAME } from 'src/ui/shared/ui/vg-progress/vg-progress.component';

@Component({
    selector: 'vg-purchase',
    templateUrl: './purchase.component.html',
    styleUrls: ['./purchase.component.scss'],
})
export class PurchaseComponent implements OnInit, AfterContentChecked {
    public currentProgress: PROGRESS_NAME = 'design';
    constructor(
        private readonly store: Store<{ currentProgress: PROGRESS_NAME }>,
        private readonly cdref: ChangeDetectorRef,
    ) {}
    ngAfterContentChecked(): void {
        this.cdref.detectChanges();
    }
    ngOnInit() {
        this.store
            .select('currentProgress')
            .subscribe(
                (currentProgress) => (this.currentProgress = currentProgress),
            );
    }
}
